import {Component, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {MatPaginator} from '@angular/material/paginator';
import {HttpService} from '../../core';
import {environment} from '../../../environments/environment';
import {UserService} from '../../core/services/user.service';
import {finalize} from 'rxjs/operators';

/**
 * @class DashboardComponent
 * @description The components set the layout and logic for dashboard
 */
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],

})


export class DashboardComponent implements OnInit {

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  isLoading: boolean;
  myProjects: any;
  SERVER_URL = environment.SERVER_URL;
  currentUserId: any;
  user: any;
  page = 0;
  pageSize = 5;
  total = 0;
  totalPages = 0;
  first = true;
  last = false;
  visitorsDistribution = {
    title: 'Visitors Distribution',
    colors: ['#556ee6', '#05CD99', '#8676FF', '#A7E7F2', '#FFAD47', '#E95513'],
    legendData: ['Melbourne', 'Sydney', 'Brisbane', 'Bendigo', 'Gold Coast', 'Others'],
    seriesData: [{value: 38, name: 'Melbourne'}, {value: 25, name: 'Sydney'}, {value: 21, name: 'Brisbane'}, {
      value: 6,
      name: 'Bendigo'
    }, {value: 3, name: 'Gold Coast'}, {value: 7, name: 'Others'}]
  };
  visitorsSource = {
    title: 'Visitors Source',
    colors: ['#556ee6', '#05CD99', '#8676FF', '#A7E7F2', '#FFAD47', '#E95513', '#454F85'],
    legendData: ['Yephome', 'Facebook', 'Twitter', 'Wechat', 'SMS', 'Email', 'Others'],
    seriesData: [{value: 45, name: 'Yephome'}, {value: 19, name: 'Wechat'}, {value: 16, name: 'Facebook'}, {
      value: 10,
      name: 'Twitter'
    }, {value: 5, name: 'Email'}, {value: 3, name: 'SMS'}, {value: 2, name: 'Others'}]
  };
  visitorsLanguage = {
    title: 'Visitors Language',
    colors: ['#556ee6', '#05CD99', '#8676FF', '#A7E7F2', '#FFAD47', '#E95513'],
    legendData: ['English', 'Mandarin', 'Spanish', 'Italian', 'Vietnamese', 'Others'],
    seriesData: [{value: 31, name: 'English'}, {value: 29, name: 'Mandarin'}, {value: 15, name: 'Spanish'}, {
      value: 13,
      name: 'Italian'
    }, {value: 7, name: 'Vietnamese'}, {value: 5, name: 'Others'}]
  };
  orderPercentage = {
    title: 'Transaction Conversion Percentage',
    colors: ['#556ee6', '#05CD99'],
    legendData: ['Yes (28%)', 'No (72%)'],
    seriesData: [{value: 28, name: 'Yes (28%)'}, {value: 72, name: 'No (72%)'}]

  };
  customerType = {
    title: 'Customer Type',
    colors: ['#556ee6', '#05CD99', '#8676FF'],
    legendData: ['New Customer', 'Purchased Customer', 'Multiple Visit Customer'],
    seriesData: [{value: 30, name: 'New Customer'}, {value: 23, name: 'Purchased Customer'}, {
      value: 47,
      name: 'Multiple Visit Customer'
    }]
  };
  referralsChanel = {
    title: 'Referral Channels',
    colors: ['#556ee6', '#8676FF', '#A7E7F2', '#05CD99', '#FFAD47', '#E95513', '#454F85'],
    legendData: ['Television ads', 'Social Media', 'Digital ads', 'Website', 'YepHome', 'Agency', 'Others'],
    seriesData: [{value: 24, name: 'Agency'}, {value: 13, name: 'Phone calls'}, {
      value: 12,
      name: 'Digital ads'
    }, {value: 5, name: 'Television ads'}, {value: 4, name: 'Website'}, {value: 4, name: 'YepHome'}, {
      value: 6,
      name: 'Others'
    }]
  };


  statusesData = (status) => {
    const statuses = [
      {
        id: -2,
        name: 'Invisible'
      },
      {
        id: -1,
        name: 'Under Approval'
      },
      {
        id: 0,
        name: 'Disabled'
      },
      {
        id: 1,
        name: 'Enable'
      }
    ];
    const info = statuses.find(item => {
      return item.id == status
    })
    return info?.name
  }

  constructor(private httpService: HttpService, private userService: UserService, private router: Router,) {
    this.isLoading = false;
  }

  ngOnInit() {
    this.userService.currentUser.subscribe((user: any) => {
      this.user = user;
      // Load projects after user is available
      if (this.user?.company?.id) {
        this.loadMyProjects();
      }
    });
    this.currentUserId = this.userService.getCurrentUser().idOrigin;
  }

  /**
   * @function loadMyProjects
   * @description Fetch paginated projects for dashboard grid
   */
  loadMyProjects() {
    // turn on loading before sending request
    this.isLoading = true;
    this.httpService
      .searchProjects(this.user.company.id, "", this.page, this.pageSize)
      // ensure loading flag is reset whether success or error
      .pipe(finalize(() => {
        this.isLoading = false;
      }))
      .subscribe((res: any) => {
        console.log('getAllSimpleProjectsByUser=>', res);
        if (res.code === 1) {
          const pageResp = res.data?.[0];
          const data = pageResp?.content || [];
          // capture pagination metadata
          this.total = pageResp?.totalElements || 0;
          this.totalPages = pageResp?.totalPages || 0;
          this.first = !!pageResp?.first;
          this.last = !!pageResp?.last;
          const temp = data.filter(project => project.name === 'West Side Place -Tower A' || project.name === 'West Side Place -Tower B');
          const exclude = data.filter(project => project.name !== 'West Side Place -Tower A' && project.name !== 'West Side Place -Tower B');
          this.myProjects = temp.concat(exclude);
          this.myProjects.map((p: any) => {
            this.httpService.getSuburbPopulation(p.postCode).subscribe((r: any) => {
              console.log(r);
              if (r.code === 1) {
                const suburb = p.area;
                console.log(suburb);
                if (r.data.doc) {
                  p.demography = r.data.doc.filter(item => this.trim(item.suburb_name.toLowerCase()) === suburb.toLowerCase())[0];
                }
                if (p.demography) {
                  if (p.demography.rent_rate) {
                    const owner = p.demography.rent_rate['Owned outright'].number + p.demography.rent_rate['Owned with a mortgage'].number;
                    const rented = p.demography.rent_rate.Rented.number;
                    p.owner = owner;
                    p.rented = rented;
                    if (owner >= rented) {
                      p.rentRatio = (owner / rented).toFixed(1);
                    } else {
                      p.rentRatio = (rented / owner).toFixed(1);
                    }
                  }
                  if (p.demography.employment) {
                    const employed = p.demography.employment['Worked full-time'].number + p.demography.employment['Worked part-time'].number + p.demography.employment['Away from work'].number;
                    const unemployed = p.demography.employment.Unemployed.number;
                    p.employed = employed;
                    p.unemployed = unemployed;
                    if (employed >= unemployed) {
                      p.employRatio = (employed / unemployed).toFixed(1);
                    } else {
                      p.employRatio = (unemployed / employed).toFixed(1);
                    }
                  }
                  if (p.demography.age_in_group) {
                    p.demography.age_group_sorted = Object.entries(p.demography.age_in_group).sort((a: any, b: any) => b[1].percentage - a[1].percentage);
                  }
                  if (p.demography.occupation) {
                    p.demography.occupation_sorted = Object.entries(p.demography.occupation).sort((a: any, b: any) => b[1].percentage - a[1].percentage);
                  }
                }
              }

            });

          });

        } else {
          this.myProjects = [];
        }
      }, (err) => {
        // handle error path to avoid stale UI state
        console.error('searchProjects error', err);
        this.myProjects = [];
        this.total = 0;
        this.totalPages = 0;
        this.first = true;
        this.last = false;
      });
  }

  // 去掉前后空格
  trim(str) {
    return str.replace(/(^\s*)|(\s*$)/g, '');
  }


  clickProjectItem(project) {
    this.router.navigateByUrl('/projects/' + project.id).then(r => {

    });
  }

  /**
   * @function onPageChange
   * @description Handle paginator page change event and reload dashboard data
   */
  onPageChange(event: any) {
    this.page = event.pageIndex;
    this.pageSize = event.pageSize;
    this.loadMyProjects();
  }

}
